import React from 'react'
import { IndexLayoutLoading } from 'components/IndexLayout'

export const WorkspaceSubscribeLoadingPage = () => (
  <IndexLayoutLoading variant="green" />
)
